const { getTime } = require('./getTime')

/**
 * Visszaadja az aktuális időt..
 * @returns {string} Az ISO idő: hh:ii:ss.
 */
module.exports.getCurrentTime = function getCurrentTime () {
  return getTime(new Date())
}
